import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import Button from '../../components/Button';
import Container from '../../components/Container';
import Grid from '../../components/Grid';
import Image from '../../components/Image';
import LockSmallImg from './lock-small.svg';
import LockImg from './lock-pink.png';
import RepVisitsUpgradeForm from '../RepVisitsUpgradeForm';

import './styles.css';

const genericMessages = defineMessages({
  premiumFeature: {
    id: 'unlock.premiumFeature',
    defaultMessage: 'Premium Feature',
  },
  upgrade: {
    id: 'unlock.upgrade',
    defaultMessage: 'UPGRADE',
  },
});

class RepVisitsUnlockPremiumView extends React.PureComponent {
  static propTypes = {
    messages: PropTypes.object.isRequired,
    activeStyle: PropTypes.string.isRequired,
    hideTopHeader: PropTypes.bool,
    isUnauthorizedRole: PropTypes.bool,
  };

  static defaultProps = {
    hideTopHeader: false,
  };

  state = {
    openModal: false,
  };

  closeModal = () => {
    this.setState({ openModal: false });
  };

  showModal = () => {
    this.setState({ openModal: true });
  };

  render() {
    const { messages, activeStyle, hideTopHeader, isUnauthorizedRole } = this.props;
    const { openModal } = this.state;
    return (
      <div>
        <Grid styleName="grid-container">
          {
            !hideTopHeader && (
              <Grid.Row>
                <Grid.Column width={10}>
                  <div data-cy="repvisits-premium-view-heading" styleName="heading-text"><FormattedMessage {...messages.featureName} />
                    <span styleName="heading-text-pink">
                      <FormattedMessage {...genericMessages.premiumFeature} />
                    </span>
                    <Image src={LockSmallImg} centered alt="locked" />
                  </div>
                </Grid.Column>
              </Grid.Row>
            )
}
          <Grid.Row data-cy="repvisits-premium-view-main">
            <Container styleName={activeStyle}>
              <Grid centered columns={3}>
                <Grid.Row centered columns={1}>
                  <Grid.Column styleName="unlock-text-area" width={8}>
                    <Grid.Row>
                      <div styleName="sub-heading-text">
                        <FormattedMessage {...messages.featureHeading} />
                        { hideTopHeader && (
                          <span>
                            <span styleName="heading-text-pink">
                              <FormattedMessage {...genericMessages.premiumFeature} />
                            </span>
                            <Image src={LockSmallImg} centered alt="locked" />
                          </span>
                        )}
                      </div>
                    </Grid.Row>
                    <Grid.Row>
                      <div styleName="sub-heading-details"><FormattedMessage {...messages.featureSummary} />
                      </div>
                    </Grid.Row>
                    {!isUnauthorizedRole && (
                      <Grid.Row>
                        <Button styleName="button-upgrade" onClick={this.showModal}>
                          <FormattedMessage {...genericMessages.upgrade} />
                        </Button>
                      </Grid.Row>
                    )}
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Image src={LockImg} centered alt="locked" styleName="image-margin" />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row centered columns={2} styleName="summary-row">
                  <Grid.Column styleName="summary-text-area" width={12}>
                    <p styleName="summary-text">
                      <FormattedMessage
                        {...messages.featureUnlockDetails}
                        values={{
                          strong: (...chunks) => <strong>{chunks}</strong>,
                        }}
                      />
                    </p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </Grid.Row>
          <RepVisitsUpgradeForm open={openModal} onClose={this.closeModal} />
        </Grid>
      </div>
    );
  }
}

export default RepVisitsUnlockPremiumView;
